
import WDDropdownForm from './wd-dropdown-form';

/**
	* just like WDDropdownForm except the value is stored as an object
	*/
export default class WDDropdownObjectForm extends WDDropdownForm {

	get value() { 
		return this.options.find(opt => this.value.includes(opt.value)) || null; 
	};

	set value(val) {
		super.value = val.value;
	};
};

customElements.define('wd-dropdown-object-form',WDDropdownObjectForm);
